module.exports = __webpack_public_path__ + "static/media/inner_circle.3181e46b.png";